import { MantineDateInput } from '@dealstack/frontend/shared/components/mantineForm/MantineDateInput';
import {
	INVESTOR_TEST_ELEMENT_ID,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { PhoneNumberInput } from '@dealstack/frontend/shared/components/forms/PhoneNumberInput/PhoneNumberInput';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex, Title } from '@mantine/core';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';

interface Props {
	disabled?: boolean;
	firstNameFieldName: string;
	lastNameFieldName: string;
	birthDayFieldName: string;
	phoneNumberFieldName: string;
	telephonePrefixFieldName: string;
}

const PersonalInformationInput = ({
	disabled,
	firstNameFieldName,
	lastNameFieldName,
	birthDayFieldName,
	phoneNumberFieldName,
	telephonePrefixFieldName,
}: Props) => {
	const tInvestor = useTranslationInvestor();
	const formContext = useFormContext();

	return (
		<Flex direction="column" gap="1rem" w="100%">
			<Title order={6}>{tInvestor('investment.personal_details.personal_information')}</Title>

			<UIElementIdentifier
				identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_FIRST_NAME}
			>
				<TextInput
					label={tInvestor(
						'investment.personal_details.personal_information_form.first_name'
					)}
					placeholder={tInvestor(
						'investment.personal_details.personal_information_form.first_name'
					)}
					control={formContext.control}
					name={firstNameFieldName}
					disabled={disabled}
					size="md"
				/>
			</UIElementIdentifier>

			<UIElementIdentifier
				identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_LAST_NAME}
			>
				<TextInput
					label={tInvestor(
						'investment.personal_details.personal_information_form.last_name'
					)}
					placeholder={tInvestor(
						'investment.personal_details.personal_information_form.last_name'
					)}
					control={formContext.control}
					name={lastNameFieldName}
					disabled={disabled}
					size="md"
				/>
			</UIElementIdentifier>

			<MantineDateInput
				label={tInvestor(
					'investment.personal_details.personal_information_form.date_of_birth'
				)}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.date_of_birth'
				)}
				data-testid={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_BIRTH_DATE}
				name={birthDayFieldName}
				maxDate={new Date()}
				disabled={disabled}
				size="md"
			/>

			<UIElementIdentifier
				identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_PHONE_NUMBER}
			>
				<PhoneNumberInput
					name={phoneNumberFieldName}
					phonePrefixName={telephonePrefixFieldName}
					disabled={disabled}
					label={tInvestor(
						'investment.personal_details.personal_information_form.phone_number'
					)}
					size="m"
				/>
			</UIElementIdentifier>
		</Flex>
	);
};
const _PersonalInformationInputExport = memo(PersonalInformationInput);

export { _PersonalInformationInputExport as PersonalInformationInput };
